
export enum InitialTypes {
  MANUALLY_CREATED = 'manuallyCreated',
  STOCK_MANAGED = 'stockManaged',
  DIFFERENTIAL_TAX = 'differentialTax',
  GRADUATED_PRICE_MANAGED = 'graduatedPriceManaged',
  DEPOSIT_INVOICE = 'depositInvoice',
  POSITIONS_GROUPED = 'positionsGrouped',
  ALTERNATIVE_POSITION = 'alternativePosition',
  OPTIONAL_POSITION = 'optionalPosition',
}
